<template>
  <v-container>
    <v-row>
      <v-col cols="1">
        <v-select :items="regions" label="依國家/領域來篩選" v-model="region"></v-select>
      </v-col>
      <v-col cols="2">
        <v-text-field
          v-model="name_search"
          append-icon="search"
          label="頻道名稱"
          placeholder="搜尋kol名稱"
          single-line
          hide-details
          :height="33"
        ></v-text-field>
      </v-col>
      <v-col class="col" style="text-align:right">
        <v-dialog v-model="create_kols" persistent max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="ma-2" tile outlined v-bind="attrs" v-on="on" color="primary">
              <v-icon left>mdi-pencil</v-icon> 新增KOL
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">新增KOL</span>
            </v-card-title>
            <v-card-text>
              <font color="red">需依照規定格式填寫kol資料喔~如有疑問可點選 kol新增範例格式，或詢問知識組莊莊~</font>
            </v-card-text>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="8">
                    <v-file-input
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      label="kol新增檔案.xlsx"
                      v-model="file"
                    ></v-file-input>
                  </v-col>
                  <v-col cols="2">
                    <div class="my-2">
                      <v-btn color="info" id="sendData" @click="createKols" :disabled="sendBtnStatus">
                        上傳<v-icon right dark>mdi-cloud-upload</v-icon>
                      </v-btn>
                      <v-progress-circular class="ma-2" indeterminate color="amber" v-if="showLoadingBar"></v-progress-circular>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <a href="http://api.i-buzz-system.com/aie-api/downloads/ibuzz-channels/kol新增格式.xlsx">kol新增範例格式</a>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="create_kols = false">關閉</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="kols"
          :single-select="false"
          :search="search"
          item-key="_id.$oid"
          show-select
          multi-sort
          class="elevation-1"
          :footer-props="{
              itemsPerPageOptions: [10,25,50,75,100]
          }"
        ></v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="my-2">
          <v-btn>下一頁</v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Axios from "axios";
import store from "@/store";
export default {
  name: "kol_management",
  data: () => ({
    kols: null,
    region: "台灣",
    regions:["印尼","台灣","新加坡","日本","泰國","澳門","菲律賓","越南","韓國","香港","馬來西亞"],
    page: 1,
    create_kols: false,
    file: null,
    headers: [
      {
        text: "id",
        align: "start",
        sortable: false,
        value: "_id",
        filterable: false
      },
      { text: "kol名稱", value: "kol_name" },
      { text: "國家/區域", value: "region" },
      { text: "領域", value: "field" },
      { text: "FB網址", value: "fb_url" },
      { text: "IG網址", value: "ig_url" },
      { text: "YT網址", value: "yt_url" }
    ]
  }),
  beforeMount: function() {
    this.kols = this.getKolData();
  },
  watch:{
      region: function(){
        this.kols = this.getKolData();
      }
  },
  methods: {
    getKolData: function() {
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + store.getters.getToken
        }
      };
      Axios.get(
        "https://api.i-buzz-system.com/basic/channelmanage/get-kol?region=" + this.region,
        config
      )
        .then(response => {
          this.kols = response.data.data;
        })
        .catch(error => {
          window.location.href = "/";
          console.log(error);
        });
    },
    createKols: function() {
      var postforms = new FormData();
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + store.getters.getToken
        }
      };
      postforms.append("file",this.file, this.file.name);
      Axios.post(
        "https://api.i-buzz-system.com/basic/channelmanage/create-kols",
        postforms,
        config
      )
        .then(response => {
          alert(response.data.msg)
        })
        .catch(error => {
          alert(error.msg)
        })
    }
  }
};
</script>